import React, { Component } from "react";

import { ActionCreators } from "../../actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { RouteWithSubRoutes } from "../../components/subrouter";
import Modal from "../../components/modal";
import Backdrop from "../../components/backdrop";

import "../../styles/oc.css";

class OCContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="oc flex-row align-items-center">
        <Modal
          show={this.props.modalIsOpen}
          closed={this.props.closeModal}
          options={this.props.modalOptions}
        />
        {this.props.modalIsOpen ? <Backdrop show /> : null}
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-4">
              {this.props.routes.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    modalIsOpen: state.modalIsOpen,
    modalOptions: state.modalOptions
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OCContainer)
);



// WEBPACK FOOTER //
// ./src/pages/unauth/ocContainer.js